$(function() {
    if($('body').hasClass('for-healthcare-professionals')){
        // Sticky Nav

            // Add padding to Sticky Nav sections on page load
            if ($(window).width() > 640) {
                let stickyNavHeight = $('#sticky-nav').outerHeight();   // Get height of sticky-nav
                $(window).on('load resize', function () {
                    $('.sticky-section').css('padding-top', stickyNavHeight);
                });
            } else {
                let stickyMobileNavHeight = $('#sticky-nav').outerHeight();
                $(window).on('load resize', function () {
                    $('.sticky-section').css('padding-top', stickyMobileNavHeight);
                });
            }


            // Sticky nav attachment on scroll
            let stickyNav = $('#sticky-nav').offset().top;

            $(document).scroll(function() {
                if ($(window).scrollTop() > stickyNav) {
                    $('#sticky-nav').addClass('is-sticky');
                } else {
                    $('#sticky-nav').removeClass('is-sticky');
                }
            });


            // Class change and diamond movement on scroll
                // Cache the navigation links
                var $stickynavlinks = $('a.sticky-nav-item');
                // Cache (in reversed order) the sections
                var $sections = $($(".sticky-section").get().reverse());

                // Map each section id to their corresponding navigation link
                var sectionIdTonavigationLink = {};
                $sections.each(function() {
                    var id = $(this).attr('id');
                    sectionIdTonavigationLink[id] = $('a.sticky-nav-item[href="#' + id + '"]');
                });
                // Throttle function, enforces a minimum time interval
                function throttle(fn, interval) {
                    var lastCall, timeoutId;
                    return function () {
                        var now = new Date().getTime();
                        if (lastCall && now < (lastCall + interval) ) {
                            // if we are inside the interval we wait
                            clearTimeout(timeoutId);
                            timeoutId = setTimeout(function () {
                                lastCall = now;
                                fn.call();
                            }, interval - (now - lastCall) );
                        } else {
                            // Otherwise, we directly call the function
                            lastCall = now;
                            fn.call();
                        }
                    };
                }
                function highlightNavigation() {
                    // Get the current vertical position of the scroll bar
                    var scrollPosition = $(window).scrollTop();

                    // Iterate the sections
                    $sections.each(function() {
                        var currentSection = $(this);
                        // Get the position of the section (minus 3 for border compensation)
                        var sectionTop = currentSection.offset().top - 3;

                        // If the user has scrolled over the top of the section
                        if (scrollPosition >= sectionTop) {
                            // Get the section id
                            var id = currentSection.attr('id');
                            // Get the corresponding navigation link
                            var $navigationLink = sectionIdTonavigationLink[id];
                            // If the link is not active
                            if (!$navigationLink.hasClass('active')) {
                                // Remove .active class from all the links
                                $stickynavlinks.removeClass('active');
                                // Add .active class to the current link
                                $navigationLink.addClass('active');
                                // Move sticky-diamond according to location of active element
                                if ($(window).width() > 640) {
                                    var $navLinkPos = $navigationLink.position();
                                    var $navLinkPosLeft = $navLinkPos.left;
                                    var $navLinkWidthHalf = $navigationLink.innerWidth() / 2;
                                    var $diamondLeft = $navLinkPosLeft + $navLinkWidthHalf - 12; // Minus 12px for the width of the diamond
                                    $('.sticky-diamond').css('left', $diamondLeft);
                                } else {
                                    var $navigationText = $navigationLink.html();
                                    $('.sticky-nav-button span').html($navigationText);
                                }
                            }
                            // We have found our section, so we return false to exit the each loop
                            return false;
                        }
                    });
                }

                $(document).scroll( throttle(highlightNavigation,100) );


            // Sticky Mobile
            $('.sticky-nav-button, .sticky-nav-mobile a.sticky-nav-item').click(function() {
                $('.sticky-nav-mobile').slideToggle();
            });

        // Join the Community
            $('.testimonial-carousel').slick({
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: true,
                infinite: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 641,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                            dots: true
                        }
                    }
                ]
            });

            // Matching Element Height
            $(window).on('load', function(){
                function setHeight(elementH) {
                    var maxH = 0;
                    var len = $(elementH).length;
                    $(elementH).css('min-height', '');

                    $(elementH).each(function (index) {
                        var curH = $(this).outerHeight();
                        if (curH > maxH) {
                            maxH = curH;
                        }

                        if ((index + 1) == len) {
                            $(elementH).css({ 'min-height': maxH });
                        }
                    });
                }

                setHeight('.testimonial-info'); // Testimonial slide content
            });


        // Newsletter
        document.addEventListener('wpcf7mailsent', function( event ) {
            dataLayer.push({
                'event' : 'emailSuccess'
            })
        }, false );

        document.addEventListener('wpcf7mailfailed', function( event ) {
            dataLayer.push({
                'event' : 'emailError'
            })
        }, false );

        // Modal
        if (typeof $.cookie('healthcare-modal') === 'undefined'){
            $('#healthcare-modal').foundation('open')
        }

        $('#healthcare-modal').on('click', '.proceed', function(e){
            e.preventDefault()
            $.cookie('healthcare-modal', '1', { path: '/' })
            $('#healthcare-modal').foundation('close')
        })

        $('#healthcare-modal').on('click', '.cancel', function(e){
            e.preventDefault()
            $('#healthcare-modal').foundation('close')
        })
    }
})